import { createClient } from "@connectrpc/connect";
import { IDeleteService } from "../../../abstractions/services/actions/IDeleteService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { AplicacionService } from "../../../generated/grpc/aplicaciones_pb";
import { grpcAplicacionDatabase } from "../database/GrpcAplicacionDatabase";
import { AplicacionResponse } from "../response/AplicacionResponse";
import { fx_createAplicacionGrpcService } from "./AplicacionGrpcService";

/** Variante gRPC-Web de `AplicacionDeleteService` (ver ese archivo): mismo
 *  contrato `IDeleteService`. Tras eliminar, borra la aplicación de
 *  `grpcAplicacionDatabase` al toque -no hace falta esperar al próximo
 *  delta, que igual la traería con `eliminado = true`-. */
export class AplicacionDeleteGrpcService
  implements IDeleteService<AplicacionResponse>
{
  async deleteAsync(item: AplicacionResponse): Promise<void> {
    const client = createClient(AplicacionService, grpcTransportProvider.get());

    try {
      await client.eliminar({ id: item.id });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcAplicacionDatabase.deleteOneAsync(item.id);
    fx_createAplicacionGrpcService(item.fincaId).clearCache();
  }
}
